module.exports = "/_next/static/images/man-9b647c07f5115138119c44d21f1afe72.svg";